import styled from 'styled-components';

/*
 * 18x18 info-circle icon (Figma 16677-57204). The visual box is 18px; the
 * transparent `::before` only enlarges the hit area (24x24, and 44x44 on
 * coarse pointers) without shifting anything in the row. `z-index: 1` puts it
 * above the selection button's `::after`, which covers the accordion row.
 */
export const Button = styled.button`
  position: relative;
  z-index: 1;
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #737373;
  cursor: pointer;
  transition: color 0.15s ease;

  &::before {
    content: '';
    position: absolute;
    inset: -3px;
    border-radius: 50%;
  }

  @media (pointer: coarse) {
    &::before {
      inset: -13px;
    }
  }

  /* Drops the button:hover background from globalStyles. */
  &:hover {
    background: transparent;
    color: #404040;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent.primary};
    outline-offset: 2px;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
